export default __webpack_public_path__ + "static/media/hult.a0532ae0.png";